import "./results.css";
import { useState } from "react";
import Table from "react-bootstrap/Table";

import Business from "./business";

function Results({ businessData }) {
  const [showBusiness, setShowBusiness] = useState(false);
  const [biznessData, setBiznessData] = useState();
  const [reviewData, setReviewData] = useState();

  const handleItemClick = (businessId) => {
    fetch("/businesses/" + businessId)
      .then((res) => res.json())
      .then((data) => {
        setBiznessData(data);
        setShowBusiness(true);
      });

    fetch("/businesses/" + businessId + "/reviews")
      .then((res) => res.json())
      .then((data) => {
        setReviewData(data);
      })
      .catch((error) => {
        
      });
  };
  const handleBackClick = () => {
    setShowBusiness(false);
  };

  const dataRows = businessData.slice(0, 10).map((info, i) => {
    return (
      <tr key={i + 1} onClick={() => handleItemClick(info.id)}>
        <td>
          <b>{i + 1}</b>
        </td>
        <td>
          <img src={info.image_url} style={{'maxWidth':'20vw','maxHeight':'20vw'}} alt=""></img>
        </td>
        <td>{info.name}</td>
        <td>{info.rating}</td>
        <td>{Math.round(info.distance / 1609.34)}</td>
      </tr>
    );
  });
  return (
    <div className="results mx-auto">
      {showBusiness === false && (
        <Table striped className="w-100">
          <thead>
            <tr>
              <th>#</th>
              <th>Image</th>
              <th>Business Name</th>
              <th>Rating</th>
              <th>Distance (Miles)</th>
            </tr>
          </thead>
          <tbody>{dataRows}</tbody>
        </Table>
      )}
      {showBusiness === true && (
        <Business
          oneBusinessData={biznessData}
          oneBusinessReviews={reviewData}
          handleBackClick={handleBackClick}
        ></Business>
      )}
    </div>
  );
}
export default Results;
